import React, { useEffect } from 'react';
import '../Assets/Additionalcss/Oatcss.css'
import oatlogo from '../Assets/Images/oat.png'
import {Link} from 'react-router-dom'
import { useLocation } from "react-router-dom";

function Oatsidebar({sidebar,openLogForm}) {


   
    

     let role;

     useEffect(()=>{

         role=localStorage.getItem('RoleId');

         if(role==='00'){

            document.getElementById("oat-Adduser").style.display="none"
            document.getElementById("oat-Assign").style.display="none"
         }
         else if (role==='01'){

            document.getElementById("oat-Adduser").style.display="block"
            document.getElementById("oat-Assign").style.display="block"
         }

         else{

            document.getElementById("oat-Adduser").style.display="none"
            document.getElementById("oat-Assign").style.display="none"
         }
           
        },[]);

    //assigning location variable
    const location = useLocation();

    //destructuring pathname from location
    const { pathname } = location;

    //Javascript split method to get the name of the path in array
    const splitLocation = pathname.split("/");

   

    return (
<div className ={sidebar ? "OAT-sidebar OAT-sidebar--open" : "OAT-sidebar"}  id="OAT-sidebar">
    <div className='OAT-sidebar-title'>
        <div className='OAT-sidebar-img'>
             {/* <img src={oatlogo} alt="logo"/>&nbsp;&nbsp; */}
             <Link to="/OAT"><span>One Awesome Team</span></Link> 
        </div>
      
    </div>

   <div className='OAT-sidebar-menu'>
 
    
    <div className={splitLocation[1] === "Oatadduser" ? "active-oat" : "OAT-sidebar-link"} id="oat-Adduser">
    <i class="fa fa-user-o" id="OatSideIcon"></i>&nbsp; &nbsp;
        <Link to="/Oatadduser">Users</Link> 
    </div>
  
    <div className={splitLocation[1] === "OatProfile" ? "active-oat" : "OAT-sidebar-link"}>
    <i class="fa fa-address-book-o" id="OatSideIcon"></i>&nbsp; &nbsp;
        <Link to="/OatProfile">Profile</Link> 
    </div>
   
    <div className={splitLocation[1] === "Oatsection" ? "active-oat" :
    splitLocation[1] ==="OatHome" ? "active-oat":
    splitLocation[1] ==="OatEntity" ? "active-oat":
    splitLocation[1] ==="OatCategory" ? "active-oat": 
    splitLocation[1] ==="OatAnnouncement" ? "active-oat":
    splitLocation[1] ==="OatSkill" ? "active-oat":
    splitLocation[1] ==="OatDesignation" ? "active-oat":
    splitLocation[1] ==="OatEducation" ? "active-oat": 
    splitLocation[1] ==="OatDepartment" ? "active-oat":"OAT-sidebar-link"}>
    <i class="fa fa-list-alt" id="OatSideIcon"></i>&nbsp; &nbsp;
        <Link to="/Oatsection">Section</Link> 
    </div>
 

    

    <div className={splitLocation[1] === "Oatassign" ? "active-oat" : "OAT-sidebar-link"} id="oat-Assign">
    <i class="fa fa-code-fork" id="OatSideIcon"></i>&nbsp; &nbsp;
        <Link to="/Oatassign">Assign</Link> 
    </div>


    <div className='OAT-sidebar-link' id="logout">
    <i class="fa fa-sign-out fa-fade fa-xs" id="OatSideIcon"></i>&nbsp; &nbsp;
        <Link to=' ' onClick={openLogForm}>Logout</Link> 
    </div>
   
    
   </div>
   
    </div>
    );
}

export default Oatsidebar;